import MenuItem from './MenuItem';
import { ReactComponent as PlaylistIcon } from '../../icons/playlist.svg';

export default function PublisherViewOfRightsholderMenu({ open }) {
  return (
    <>
      <MenuItem open={open} path="/video-library" label="Video Library">
        <PlaylistIcon />
      </MenuItem>
    </>
  );
}

